/*=====================================
    HelpViewSideBar

    Author: Ac
    CreateTime: 2018 / 09 / 13
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React from 'react';
import { SideBarStyle } from 'stylecomponents';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import CupoySrefView from 'components/commons/router/CupoySrefView';
/**
|--------------------------------------------------
|  Variables
|--------------------------------------------------
*/
const NAVS = [
    {
        title: '新手上路',
        items: [
            {
                name: '如何升級會員',
                routerState: CupoyRouter.STATES.HELP_UPGRADE_MEMBERSHIP,
                icon: { className: 'zmdi zmdi-account', size: 26 },
            },
            {
                name: '會員停權',
                routerState: CupoyRouter.STATES.HELP_MEMBER_SUSPENSION_OF_POWER,
                icon: { className: 'zmdi zmdi-lock', size: 20 },
            }
        ],
    },
    {
        title: '交易須知',
        items: [
            {
                name: '交易安全',
                routerState: CupoyRouter.STATES.HELP_TRANSACTION_SECURITY,
                icon: { className: 'zmdi zmdi-shield-security', size: 20 },
            },
            {
                name: '繳費說明',
                routerState: CupoyRouter.STATES.HELP_TRANSACTION_ORDER,
                icon: { className: 'zmdi zmdi-file', size: 20 },
            },
        ],
    },
    {
        title: '發財金',
        items: [
            {
                name: '何謂發財金',
                routerState: CupoyRouter.STATES.HELP_BONUS_BASE_INTRO,
                icon: { className: 'zmdi zmdi-money', size: 20 },
            },
            {
                name: '如何計算',
                routerState: CupoyRouter.STATES.HELP_BONUS_CALC_INTRO,
                icon: { className: 'zmdi zmdi-plus', size: 20 },
            },
            {
                name: '參加資格',
                routerState: CupoyRouter.STATES.HELP_BONUS_ELIGIBILITY,
                icon: { className: 'zmdi zmdi-assignment-o', size: 18 },
            },
            {
                name: '如何使用',
                routerState: CupoyRouter.STATES.HELP_BONUS_MANUAL,
                icon: { className: 'zmdi zmdi-zoom-in', size: 20 },
            },
        ],
    },
    {
        title: '其他',
        items: [
            {
                name: '關於淞果',
                routerState: CupoyRouter.STATES.HELP_ABOUT,
                icon: { className: 'zmdi zmdi-city', size: 20 },
            },
            {
                name: '免責聲明',
                routerState: CupoyRouter.STATES.DISCLAIMER,
                icon: { className: 'zmdi zmdi-info-outline', size: 20 },
            },
            {
                name: '會員條款',
                routerState: CupoyRouter.STATES.MEMBER_TERMS,
                icon: { className: 'zmdi zmdi-accounts-alt', size: 20 },
            },
            {
                name: '隱私權聲明',
                routerState: CupoyRouter.STATES.HELP_PRIVACY_POLICY,
                icon: { className: 'zmdi zmdi-info-outline', size: 20 },
            }
            // {
            //     name: '訪客留言',
            //     routerState: CupoyRouter.STATES.HELP_VISITOR_BOOK,
            //     icon: { className: 'zmdi zmdi-comment-more', size: 20 },
            // }
        ],
    },
];
/*--------------------------
    Styled
--------------------------*/
/*--------------------------
    Main Component
--------------------------*/
const HelpViewSideBar = () => (
    <SideBarStyle.Container>
        {
            NAVS.map(({ title, items }) => (
                <SideBarStyle.Section key={title}>
                    <SideBarStyle.SectionTitle>
                        {title}
                        <SideBarStyle.SpreadIcon>
                            <i className="zmdi zmdi-caret-down"></i>
                        </SideBarStyle.SpreadIcon>
                    </SideBarStyle.SectionTitle>
                    <SideBarStyle.Nav>
                        {
                            items.map(({ name, routerState, icon }) => (
                                <SideBarStyle.NavItem isActive={CupoyRouter.isActive(routerState)} key={name}>
                                    <CupoySrefView
                                        statename={routerState}
                                        stylecomponent={SideBarStyle.NavItemContent}
                                    >
                                        <SideBarStyle.NavItemSimpleIcon
                                            size={icon.size}
                                        >
                                            <i className={icon.className}></i>
                                        </SideBarStyle.NavItemSimpleIcon>
                                        <SideBarStyle.NavItemText>{name}</SideBarStyle.NavItemText>
                                    </CupoySrefView>
                                </SideBarStyle.NavItem>
                            ))
                        }
                    </SideBarStyle.Nav>
                </SideBarStyle.Section>
            ))
        }
    </SideBarStyle.Container>
);
/*--------------------------
    Export
--------------------------*/
export default HelpViewSideBar;